// import './page.scss';

export { default } from './Page';
export { default as template } from './page.tpl';
